var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('D24Image',_vm._b({staticClass:"comment-avatar img-avatar",attrs:{"fallback":_vm.fallback}},'D24Image',_vm.image,false))}
var staticRenderFns = []

export { render, staticRenderFns }